export const STRIPE_PUBLIC_KEY =
	"pk_test_51Omx9nFTutYhJ7c8SH2OAQeLAoSm8rvvCYJbMhhGIq0Oo9NbuDwRYlIJkWsT9qAvZdbyzspcGux7PmGVjyHPoEBN00oz0VR7Vt";

export const GEOS = [
	{
		name: "New York",
		geocode: {
			latitude: 40.7128,
			longitude: -74.006,
		},
	},
	{
		name: "Los Angeles",
		geocode: {
			latitude: 34.0522,
			longitude: -118.2437,
		},
	},
	{
		name: "Chicago",
		geocode: {
			latitude: 41.8781,
			longitude: -87.6298,
		},
	},
	{
		name: "Houston",
		geocode: {
			latitude: 29.7604,
			longitude: -95.3698,
		},
	},
	{
		name: "Phoenix",
		geocode: {
			latitude: 33.4484,
			longitude: -112.074,
		},
	},
	{
		name: "Philadelphia",
		geocode: {
			latitude: 39.9526,
			longitude: -75.1652,
		},
	},
	{
		name: "San Antonio",
		geocode: {
			latitude: 29.4241,
			longitude: -98.4936,
		},
	},
	{
		name: "San Diego",
		geocode: {
			latitude: 32.7157,
			longitude: -117.1611,
		},
	},
	{
		name: "Dallas",
		geocode: {
			latitude: 32.7767,
			longitude: -96.797,
		},
	},
	{
		name: "San Jose",
		geocode: {
			latitude: 37.3382,
			longitude: -121.8863,
		},
	},
];
